import "./login.sass";
import { createContext, useEffect, useState, useRef } from "react";
import { MessageBox } from "../../components_new/message/message";
import { useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../hooks-store/store";
import { validateUser } from "./validate-user";
import { LoadingScreen } from "../../components_new/loadingspinner/loading-screen";
import { LOCALSTORAGEKEYS, SESSIONSTORAGEKEYS } from "../../common/constants";
import { LoginComponent } from "./login_components/loginComponents";
import { AlertMessage } from "../../components_new/alerts/alert-message";

const LoginContext = createContext();

export const AlertContext = createContext(null);

let alertsId = 0;

export const Login = () => {
  const [messageProps, setMessageProps] = useState();
  const [loading, setLoading] = useState(false);
  const [store, dispatch] = useStore();
  const { pathname } = useLocation();
  const current_workspace = localStorage.getItem(LOCALSTORAGEKEYS.CURRENT_WORKSPACE);
  const [alerts, setAlerts] = useState([]);
  const removedAlerts = useRef(new Set());

  const navigate = useNavigate();

  const navigateToNextPage = () => {
    let navigateToPath = "/";
    if (sessionStorage.getItem(SESSIONSTORAGEKEYS.TO_REDIRECT_PAGE)) {
      navigateToPath = sessionStorage.getItem(SESSIONSTORAGEKEYS.TO_REDIRECT_PAGE);
      sessionStorage.removeItem(SESSIONSTORAGEKEYS.TO_REDIRECT_PAGE);
    } else if (current_workspace && !pathname.includes(current_workspace)) {
      navigateToPath = `/${current_workspace}`;
    }
    navigate(navigateToPath);
  };

  const success = (data) => {
    dispatch("SAVE_JWT_TOKEN", [data?.accessToken, data?.expiration, data?.refreshAccessToken, data?.ssoToken]);
    dispatch("SAVE_USERNAME", data?.userData?.username);
    dispatch("SAVE_USER", data?.userData);
   navigateToNextPage();
  };

  useEffect(() => {
    if (validateUser(store, dispatch)) {
      navigateToNextPage();
   }
  }, []);

  const enableAlert = ({ type = "success", text = "", time = 8000, navigateHome = false, darkerVersion = false }) => {
    let al = alerts;
    const temp = { alertText: text, alertVariant: type, time: time, id: alertsId++, darkerVersion: darkerVersion };
    al = al.filter((x) => !removedAlerts.current.delete(x.id) && x.alertVariant !== temp.alertVariant && x.alertText !== temp.alertText);
    al.push(temp);
    setAlerts(() => [...al]);
  };

  const removeAlert = (id) => {
    removedAlerts.current.add(id);
  };

  return (
    <LoginContext.Provider value={{ setMessageProps, success, setLoading }} style={{ backgroundColor: "red" }}>
      <AlertContext.Provider value={{ enableAlert, alerts: alerts, removeAlert,  width: '10px' }}>
        <AlertMessage />
        <LoadingScreen loading={loading} />
        <LoginComponent LoginContext={LoginContext} />
        <MessageBox show={messageProps} close={() => setMessageProps(null)} messageType={messageProps?.status} messageText={messageProps?.text} />
      </AlertContext.Provider>
    </LoginContext.Provider>
  );
};
